module.exports = __webpack_public_path__ + "media/images/post_1-f703cf58772f832177f24fd2199743fc.svg";